import { render, staticRenderFns } from "./SeniorMemberAssign.vue?vue&type=template&id=42006bce"
import script from "./SeniorMemberAssign.vue?vue&type=script&lang=js"
export * from "./SeniorMemberAssign.vue?vue&type=script&lang=js"
import style0 from "./SeniorMemberAssign.vue?vue&type=style&index=0&id=42006bce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports